import * as React from "react";
import { Calendar, MapPin, Trophy } from "lucide-react";
import { Badge } from "@/components/ui/badge";
const tournamentDetails = [{
  icon: Calendar,
  text: "15-17 Août 2024"
}, {
  icon: MapPin,
  text: "Stade de France, Paris"
}, {
  icon: Trophy,
  text: "Catégorie U15"
}];
export default function TournamentOverview() {
  return <section id="aperçu-du-tournoi" className="relative w-full min-h-[60vh] md:min-h-[70vh] flex items-end pb-24 md:pb-32 overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647492/img/tournament_action_stadium.png')] bg-cover bg-center grayscale-[40%] contrast-125" />

      {}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/30 via-transparent to-transparent mix-blend-overlay" />

      {}
      <div className="absolute inset-0 bg-gradient-to-t from-[hsl(220_15%_7%)] via-[hsl(220_15%_7%/0.7)] to-transparent" />

      {}
      <div className="relative z-10 container mx-auto px-4 flex flex-col items-center text-center">
        {}
        <h2 className="font-serif font-bold uppercase text-5xl md:text-[84px] leading-[0.9] tracking-tight bg-gradient-to-b from-primary to-white bg-clip-text text-transparent mb-8 drop-shadow-lg">
          Aperçu du tournoi
        </h2>

        {}
        <div className="flex flex-wrap justify-center gap-3 md:gap-5">
          {tournamentDetails.map((detail, i) => <Badge key={i} data-index={i} className="bg-[hsl(220_15%_12%)] text-primary hover:bg-[hsl(220_15%_18%)] border border-[hsl(220_15%_20%)] px-4 py-2 md:px-6 md:py-2.5 text-xs md:text-sm font-serif uppercase tracking-wider rounded-sm shadow-lg flex items-center gap-2.5 transition-colors">
              <detail.icon className="w-4 h-4 md:w-5 md:h-5 text-primary/80" />
              <span className="pt-0.5">{detail.text}</span>
            </Badge>)}
        </div>
      </div>

      {}
      <div className="absolute -bottom-12 left-0 right-0 h-24 bg-background -skew-y-3 origin-bottom-right z-20 shadow-[0_-10px_30px_rgba(0,0,0,0.5)]" />
    </section>;
}